import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RoleArchiveToggleResponseSchema, type RoleArchiveToggleResponse } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useRestoreRole(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<RoleArchiveToggleResponse, unknown, void>({
    mutationFn: () =>
      client.post<RoleArchiveToggleResponse>(
        `/roles/${id}/restore`,
        undefined,
        {},
        RoleArchiveToggleResponseSchema,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['roles', 'admin-list'] });
      qc.invalidateQueries({ queryKey: ['roles', 'list'] });
      qc.invalidateQueries({ queryKey: ['role', id] });
    },
  });
}
